module.exports = __webpack_public_path__ + "static/Base_Logos_clientes_Garoto-64febd852b1a2eacf726606ae919717a.png";